import { Box, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

interface DetailsList {
    label: string;
    url: string;
}

interface DetailsLinkedIconProps {
    title: string;
    detailsList?: DetailsList[];
}

function DetailsLinkedIcon(props: DetailsLinkedIconProps) {
  const { title, detailsList = [] } = props;
  const navigate = useNavigate();

  return (<>
    <Box mt={5} style={{minWidth: '200px'}}>
      <Paper variant='outlined' 
        sx={{ height: 'fit-content', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent' }}>
        <Typography m={2} variant='h3'>{title}</Typography>
        <Box m={1}
          sx={{backgroundColor: 'transparent' }}>
          <List component='nav'>
            {detailsList.map((item: any) => {
              return (
                <ListItem key={item}>
                  <ListItemButton onClick={() => navigate(`${item.url}`)} >
                    <Grid container> 
                      <Grid item xs={12}
                        md={6}>
                        <ListItemText 
                          key={item}
                          primary={
                            <Typography component='div' 
                              textAlign='left'
                              sx={{ fontWeight: 'bolder',
                                maxWidth: '440px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'}}
                            > 
                              {item.name} 
                            </Typography>}/>
                      </Grid>
                      <Grid item md={5} >
                        <ListItemText key={item}>
                          <Typography component='div' 
                            textAlign='left'
                            sx={{ 
                              maxWidth: 'auto',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'}}
                          > 
                            {item.value} 
                          </Typography>
                        </ListItemText>
                      </Grid>
                      <Grid item md={1}> 
                        <ListItemIcon>
                          <ArrowForwardIosIcon />
                        </ListItemIcon>
                      </Grid>
                    </Grid>
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Box>
      </Paper>
    </Box>
  </>);
}

export default DetailsLinkedIcon;